import { delData, getData, postData, putData } from '../../../utils/fetch-api-util';
import { FormPartnerType, PartnerType } from '../../../types/benefit';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface PartnerRequestParams {
  take?: number;
  page?: number;
}

export interface PartnerTypeResponse {
  partners: PartnerType[];
  total: number;
}

interface SuccessResponse {
  success: boolean;
}

export const getPartnersRepository = async (url: string): Promise<any[]> => {
  const response = await getData<{}, []>(url);
  return response.data;
};
export const getPartnerListRepository = async (
  url: string,
  data?: PartnerRequestParams,
): Promise<PartnerTypeResponse> => {
  const response = await getData<PartnerRequestParams, PartnerTypeResponse>(url, data);
  return response.data;
};

export const postCreatePartnerRepository = async (payload: FormPartnerType): Promise<void> => {
  await postData<FormPartnerType, SuccessResponse>(API_URLS.PARTNER_API, payload);
};

export const putUpdatePartnerRepository = async (payload: FormPartnerType): Promise<void> => {
  await putData<FormPartnerType, SuccessResponse>(API_URLS.PARTNER_URL_WITH_ID(payload?.id || ''), payload);
};

export const deletePartnerRepository = async (id: string): Promise<void> => {
  const response = await delData<any>(API_URLS.PARTNER_URL_WITH_ID(id));
  return response.data;
};
